import { WyanokeUtil } from "../util/WyanokeUtil";

export class DisplayAuthLinks {

    public static readonly DisplayMode = {
        All: 1,
        Anonymous: 2,
        Known: 3
    };
    public static show(element: HTMLElement): void {
        const parentElement =
            $(element).parent() as unknown as HTMLElement[];
        // if(the parent element is a card-header)
        //      show the entire element
        // tslint:disable-next-line: no-unsafe-any
        if (parentElement &&
            parentElement[0].classList.contains("card-header")) {
            const elementToShow =
                parentElement[0].parentNode as HTMLElement;
            elementToShow.classList.remove("d-none");
        } else {
            parentElement[0].classList.remove("d-none");
        }
    }
    public async init(): Promise<void> {
        const profile = await WyanokeUtil.loadUserProfile(false, false);
        $("[data-display-item]").each(function (): void {
            const dataAttr = $(this).data("display-item");
            if (!dataAttr) { return; }
            // Show link if user is logged in and link requires auth
            // Show link if user is not logged in and link is for anonymous
            // tslint:disable-next-line: no-unsafe-any
            if (((!profile || profile.isLoggedIn === "False") &&
                DisplayAuthLinks.DisplayMode.Anonymous === dataAttr) ||
                // tslint:disable-next-line: no-unsafe-any
                (profile && profile.isLoggedIn === "True" &&
                    DisplayAuthLinks.DisplayMode.Known === dataAttr)) {
                DisplayAuthLinks.show(this);
            }
        });
        // hack for edit profile link
        $(".global-nav__navbar--mobile-nav .navbar-nav li.nav-item:not(.d-none):last a").css("width", "46px")
            .parent().css("max-width", "46px");
    }
}
